/**
 * @generated SignedSource<<3f4575c399dfaddd731f21918109d465>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NftPdpContractContext_nftItem$data = {
  readonly mostRecentAuction: {
    readonly auctionId: number | null;
    readonly contractAddress: {
      readonly address: string | null;
    } | null;
  } | null;
  readonly " $fragmentType": "NftPdpContractContext_nftItem";
};
export type NftPdpContractContext_nftItem$key = {
  readonly " $data"?: NftPdpContractContext_nftItem$data;
  readonly " $fragmentSpreads": FragmentRefs<"NftPdpContractContext_nftItem">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NftPdpContractContext_nftItem",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "NftAuction",
      "kind": "LinkedField",
      "name": "mostRecentAuction",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "auctionId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "EthereumAddressType",
          "kind": "LinkedField",
          "name": "contractAddress",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "address",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "NftItem",
  "abstractKey": null
};

(node as any).hash = "c2237116533c2f51cd3bb205a5b8a83e";

export default node;
